var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_d0fccf8a"]},_vm.$listeners),[_c('div',{class:(_vm.switchClass),style:(_vm._f("transRpxStyle")([(_vm.swithBGClass)])),on:{"tap":(e)=>_vm.__invoke(e, [["toggleSwitch"]])}},[_c('div',{class:["cube-switch-handle",({"cube-switch-handle-on": _vm.isOn })]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }